"use client";
import ChangeEmail from "@/components/settings/ChangeEmail";
import ChangePassword from "@/components/settings/ChangePassword";
import EditProfile from "@/components/settings/EditProfile";
import MFA from "@/components/settings/MFA";
import Providers from "@/components/settings/Providers";
import Subscription from "@/components/settings/Subscription";
import { useSession } from "@/lib/hooks/use-session";

export default function Settings() {
  const { user, updateUser } = useSession();

  return (
    <>
      {/* Settings Blocks */}
      <Subscription />
      <EditProfile user={user} updateUser={updateUser} />
      <MFA user={user} />
      <ChangePassword user={user} />
      <ChangeEmail user={user} />
      <Providers user={user} />
    </>
  );
}
